import Echo from 'laravel-echo';
import 'pusher-js';

let echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY,
  cluster: process.env.MIX_PUSHER_APP_CLUSTER,
  encrypted: true,
  // forceTLS: true,
  // wsHost: 'socket.scrummy.sh',
  // wsPort: 6001,
  // enabledTransports: ['ws', 'wss'],
  disableStats: true
});

export default echo;
